// Self-contained data for The Gutierrez Legal Team concept website.
// Sourced from MySiteCare_PH_Law_Accounting_Prospect_Dossiers_WIP/06_The_Gutierrez_Legal_Team (research snapshot 2026-08-21).
// Office address has a Parañaque (customer-facing) vs Taguig (LinkedIn HQ field) discrepancy —
// presented here with a note to confirm, per the dossier's caution. Do not invent qualifications
// or titles for team members beyond what's confirmed.
export const BIZ = {
  name: "The Gutierrez Legal Team",
  tagline: "Legal, Property & Tax Matters — One Coordinated Team",
  address: "Unit 100, FICC Business Center, 276 El Grande Ave, BF Homes, Parañaque",
  addressNote: "Public records also list a Taguig headquarters — please confirm the current office before visiting.",
  phone: "+639178909400",
  phoneDisplay: "+63 917 890 9400",
  email: "gutierrezlaw.mail@gmail.com",
  linkedin: "https://www.linkedin.com/company/thegutierrezlegalteam",
  mapEmbed: "https://www.google.com/maps?q=FICC+Business+Center+276+El+Grande+Ave+BF+Homes+Paranaque&output=embed",
};

export const DISCIPLINES = ["Legal", "Accounting", "Real Estate"];

export const SERVICES = [
  { title: "General Legal Practice", text: "General legal and property-document work.", discipline: "Legal" },
  { title: "Family Law", text: "Family law matters handled alongside property and tax concerns.", discipline: "Legal" },
  { title: "Corporate Matters", text: "General corporate legal matters for businesses.", discipline: "Legal" },
  { title: "Tax & Estate Coordination", text: "Tax planning coordinated with estate and property matters.", discipline: "Accounting" },
  { title: "Estate Planning", text: "Planning for the transfer of property and assets within a family.", discipline: "Accounting" },
  { title: "Property Transfers", text: "Legal support for property transfer transactions.", discipline: "Real Estate" },
];

export const TEAM = [
  { name: "Aizelle Marie Gutierrez", role: "Partner (publicly identified principal contact)" },
  { name: "Myron Dei Gutierrez", role: "Team member" },
];

export const HOW_WE_WORK = [
  { n: "1", title: "Reach Out", text: "Contact us by phone or email to describe your general concern." },
  { n: "2", title: "Coordinated Review", text: "Because we span legal, accounting and real-estate perspectives, your matter can be reviewed from more than one angle." },
  { n: "3", title: "Plan Together", text: "Discuss the legal, property and tax pieces of your situation as one coordinated plan." },
];

export const REPUTATION = {
  rating: "5.0",
  reviewCountLabel: "10+ public reviews",
  note: "Individual review text was not recoverable — the rating reflects the aggregate shown in current public listings.",
};
